import { render } from "./BeanRig.vue?vue&type=template&id=2e89460d"
import script from "./BeanRig.vue?vue&type=script&lang=js"
export * from "./BeanRig.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__